import { initGtm } from '@link/share/vendors/gtm';

initGtm({
  gtmId: 'GTM-PN36N79',
  environment: import.meta.env.VITE_APP_SKYTREE_ENV || '',
  environments: ['develop', 'testing', 'production', 'production-jp'],
  // This container has its own `view_item` and `begin_checkout`
  // (vendors/ga.ts), so share's same-named GA4 events must never reach it.
  ga4Events: false
});
